import { render } from "./InfoBoleto.vue?vue&type=template&id=fa7563fc"
import script from "./InfoBoleto.vue?vue&type=script&lang=js"
export * from "./InfoBoleto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__